import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { BOX_SHADOWS } from "../../constants";
import processBatchData from "../../helpers/processBatchData";
import { stateType } from "../../state";
import { BoxHeader } from "../Common/BoxHeader";
import StyledDropzone from "../Common/DropZone";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      backgroundColor: "white",
      boxShadow: BOX_SHADOWS,
      borderRadius: "10px",
      height: "300px",
      transition: "0.5s",
    },
    dropZone: {
      position: "relative",
      margin: "20px",
      marginBottom: "30px",
      height: "78%",
    },
  })
);

export function DropBatchDataBox({ state }: stateType) {
  const classes = useStyles();

  return (
    <div
      className={classes.container}
      style={{
        height:
          state.saveState.batchPrediction.batchData === undefined
            ? "500px"
            : "300px",
      }}
    >
      <BoxHeader
        title={"Dataset Drop Zone"}
        toolTip={
          "Drop a dataset and let your models make predictions across multiple rows."
        }
      ></BoxHeader>
      <div className={classes.dropZone}>
        <StyledDropzone
          state={state}
          callbackFunction={(val) => processBatchData(val, state)}
          saveOpen={false}
        ></StyledDropzone>
      </div>
    </div>
  );
}
